// eslint-disable-next-line no-shadow
export var IPublicEnumTransitionType = /*#__PURE__*/function (IPublicEnumTransitionType) {
  /** 节点更新后重绘处理 */
  IPublicEnumTransitionType[IPublicEnumTransitionType["REPAINT"] = 0] = "REPAINT";
  return IPublicEnumTransitionType;
}({});

/**
 * @deprecated use IPublicEnumTransitionType instead
 */
export var TransitionType = /*#__PURE__*/function (TransitionType) {
  /** 节点更新后重绘处理 */
  TransitionType[TransitionType["REPAINT"] = 0] = "REPAINT";
  return TransitionType;
}({});